import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addVoucherApi, deleteVoucherApi, getAllVoucherApi } from "@/api/voucher";
import { deletePointBasedApi, getAllPointBasedApi } from "@/api/pointBased";

// Thunks
export const fetchPointBasedOffer = createAsyncThunk(
  "pointBasedOffer/fetchAll",
  async (
    { restaurant_id, page = 1, search = "", status = "", per_page = 10 },
    { rejectWithValue }
  ) => {
    const params = new URLSearchParams();

    params.append("per_page", per_page);
    params.append("page", page);

    if (search) {
      params.append("search_term", search);
    }

    if (status) {
      params.append("status", status);
    }

    const res = await getAllPointBasedApi(restaurant_id, params.toString());

    if (res.status === "success") {
      return { ...res.data, search };
    }

    return rejectWithValue(res.message);
  }
);


export const deletePointBasedOfferById = createAsyncThunk(
  "pointBasedOffer/delete",
  async (id, { rejectWithValue }) => {
    const res = await deletePointBasedApi(id);
    if (res.status === "success") return id;
    return rejectWithValue(res.message);
  }
);

// Initial State
const initialState = {
  vouchers: [],
  singleVoucherCard: null,
  totalPages: 1,

  getLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,

  success: null,
  error: null,
  requestStatus: false,
  search: "",
  status: "",
  perPage: 10,
  currentPage: 1
};

// Slice
const PointBasedOfferSlice = createSlice({
  name: "pointBasedOffer",
  initialState,
  reducers: {
    clearVoucherMessages: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
      state.totalPages = 1;
      state.search = "";
    },
    setVoucherSearch: (state, action) => {
      state.search = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      // Fetch All
      .addCase(fetchPointBasedOffer.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchPointBasedOffer.fulfilled, (state, action) => {
        state.getLoading = false;
        state.vouchers = action.payload.point_base_cards;
        state.requestStatus = true;
        state.totalPages = action.payload.pagination.last_page;
      })
      .addCase(fetchPointBasedOffer.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })
      // Delete
      .addCase(deletePointBasedOfferById.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(deletePointBasedOfferById.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.vouchers = state.vouchers.filter(
          (voucher) => voucher.id !== action.payload
        );
        state.success = "Point based Reward deleted successfully!";
        state.requestStatus = true;
      })
      .addCase(deletePointBasedOfferById.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      });
  },
});

export const { clearVoucherMessages, setVoucherSearch, setStatus, setPerPage, setCurrentPage } = PointBasedOfferSlice.actions;
export default PointBasedOfferSlice.reducer;
